import React from 'react';

export enum displayModes {
	DISABLE,
	HIDE,
}

/**
 *
 */
export type withPermissionsProps = {
	/**
	 * allowed: define whether there are permissions to see a view
	 */
	allowed?: boolean;
	/**
	 * denied: to display component when allowed is false
	 */
	denied?: any; // customDisplayMode
	/**
	 * displayMode: 0 = disabled, 1 = empty, 2 = render(props.denied)
	 */
	displayMode?: number; // 'disabled' | 'empty' | 'custom'
};

export const withPermissions = (WrapperComponent: any) => {
	return class WithAuth<P> extends React.Component<P & withPermissionsProps> {
		checkPermissions(): boolean {
			const { allowed } = this.props;
			if (allowed === false) {
				return false;
			}
			return true;
		}

		render() {
			const { denied, displayMode, allowed = true, ...rest } = this.props;

			if (!('allowed' in this.props)) {
				return <WrapperComponent {...rest} />;
			}

			if (this.checkPermissions()) {
				return <WrapperComponent {...rest} />;
			} else {
				if (displayMode === 0) {
					return <WrapperComponent {...rest} disabled />;
				}
				if (displayMode === 1) {
					return <></>;
				}
				return denied ? denied : null;
			}
		}
	};
};
